import React from 'react';
import Immutable from 'immutable';

import { Node } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodePartner } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface ViewPartnersHighlightsProps {
  entities: Immutable.List<ImmutableEntity<NodePartner>>;
}

const ViewPartnersHighlights: React.FC<ViewPartnersHighlightsProps> = ({
  entities,
}) => (
  <div className="ViewPartnersHighlights">
    {entities.map((entity) => {
      const id = entity.getIn(['nid', 0, 'value']);
      const uuid = entity.getIn(['uuid', 0, 'value']);
      const langcode = entity.getIn(['langcode', 0, 'value']);
      const key = `${uuid}:${langcode}`;

      return (
        <Node
          key={key}
          id={id}
          entity={entity}
        />
      );
    })}
  </div>
);

export default ViewPartnersHighlights;
